<template>
    <div>
      <template v-for="(child) in menuData">
        <el-submenu v-if="child.children.length > 0" :index="child.path">
          <template slot="title">
            <!-- 以下两个空数组里面的值为fa,fa-file，但是登录后会报错，故删除 -->
            <i :class="child.iconCls?child.iconCls:[]"></i>
            <span slot="title">{{ $t(`routeName.${child.name}`) }}</span>
          </template>
          <menu-tree :menuData="child.children"></menu-tree>
        </el-submenu>

        <el-menu-item v-else-if="child.hiddenFlag === 'N'" :index="child.path">
          <i :class="child.iconCls?child.iconCls:[]"></i>
          <span slot="title">{{ $t(`routeName.${child.name}`) }}</span>
        </el-menu-item>
      </template>
    </div>
</template>

<script>
export default {
  name: 'menuTree',
  props: ['menuData']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/layout/aside/menuTree.vue